import LogoutIcon from "@mui/icons-material/Logout";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import Button from "@mui/material/Button";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SettingsIcon from "@mui/icons-material/Settings";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import BuildIdLogo from "../../../assets/images/build_id_logo.png";
import {
  Avatar,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Stack,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  CircularProgress
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import packageInfo from "../../../../package.json";
import { BIGrey } from "../../../assets/helpers";
import { useSelector, useDispatch } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import { English } from "../../../constant/EnglishFallback";
import { useMemo, useState } from "react";
import { Postrequestcall } from "../../../request/Postrequest";
import { DELETE_CLIENT_EMPLOYEES } from "../../../constant/Apipath";
import { setShowOrganizationModal, setLogindata, setSelectedClientdata, setSelectedAppPermissions } from "../../../redux/actions/actions";

function ProfileMenu(props) {
  const {
    anchorEl,
    onLogout,
    menuView,
    setMenView,
    onProfile,
    handleReferClick,
    onEarnbuilderBucks,
    handleCurrentClientChange,
    handleClientActive,
    selectedClientData,
    handleViewInvite // New prop
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const { menuCardBuilderBucks, loginData, multiLanguageData } = useSelector(
    (state) => state?.main
  );
  const accessToken = loginData?.accessToken;

  const {
    TEXT_ACCOUNTS = English?.ProfileCard?.TEXT_ACCOUNTS,
    TEXT_REFER_SOMEONE_TO_BUILDID = English?.ProfileCard?.TEXT_REFER_SOMEONE_TO_BUILDID,
    TEXT_ACCOUNT_ACTIVITY_HEADER = English?.ProfileCard?.TEXT_ACCOUNT_ACTIVITY_HEADER,
    TEXT_PENDING_INVITATIONS = English?.ProfileCard?.TEXT_PENDING_INVITATIONS,
    TEXT_SETTINGS = English?.ProfileCard?.TEXT_SETTINGS,
    TEXT_TUTORIAL_VIDEOS = English?.ProfileCard?.TEXT_TUTORIAL_VIDEOS,
    TEXT_LOGOUT = English?.ProfileCard?.TEXT_LOGOUT,
    TEXT_PRIVACY_POLICY = English?.ProfileCard.TEXT_PRIVACY_POLICY,
    TEXT_TERMS_AND_CONDITIONS = English.ProfileCard.TEXT_TERMS_AND_CONDITIONS,
    TEXT_BUILDID = English.ProfileCard.TEXT_BUILDID
  } = multiLanguageData?.ProfileCard || {};

  const [openLeaveModal, setOpenLeaveModal] = useState(false);
  const [clientToLeave, setClientToLeave] = useState(null);
  const [loadingLeave, setLoadingLeave] = useState(false);

  const handleClose = () => {
    document.activeElement?.blur(); // Remove focus before closing
    setMenView(false);
  };

  const sortedClientsList = useMemo(() => {
    if (!loginData?.userInformation?.ClientsList) return [];
    const clientsListRaw = loginData.userInformation.ClientsList;
    if (clientsListRaw.length === 0) return [];

    const hasOnlyDefaultDate = clientsListRaw.every(
      (obj) => obj.LastDateUsed === "1900-01-01T00:00:00"
    );
    if (hasOnlyDefaultDate) {
      return clientsListRaw.slice().sort((a, b) => {
        return (a.OrganizationName || "").localeCompare(b.OrganizationName || "");
      });
    } else {
      const sorted = clientsListRaw.slice().sort((a, b) => {
        return new Date(b.LastDateUsed) - new Date(a.LastDateUsed);
      });
      if (selectedClientData?.ClientId) {
        const idx = sorted.findIndex((c) => c.ClientId === selectedClientData.ClientId);
        if (idx > 0) {
          const [selected] = sorted.splice(idx, 1);
          sorted.unshift(selected);
        }
      }
      return sorted;
    }
  }, [loginData?.userInformation?.ClientsList, selectedClientData?.ClientId]);

  // Check if the CURRENTLY selected client has HideBiFree property
  const isCurrentClientRestricted = useMemo(() => {
    if (!selectedClientData?.ClientId || !loginData?.userInformation?.ClientsList) return false;
    const currentClient = loginData.userInformation.ClientsList.find(
      (c) => c.ClientId === selectedClientData.ClientId
    );
    return currentClient?.HideBiFree === true;
  }, [selectedClientData, loginData?.userInformation?.ClientsList]);

  const handleLeaveClick = (client) => {
    setClientToLeave(client);
    setOpenLeaveModal(true);
    setMenView(false); // Close the menu
  };

  const handleConfirmLeave = async () => {
    if (!clientToLeave) return;
    setLoadingLeave(true);

    const payload = {
      UserId: loginData?.userInformation?.UserId,
      ReturnRecordId: false,
      ReturnRecordError: true,
      SoftDelete: true,
      DeleteList: [
        {
          Id: clientToLeave.ClientEmployeeId || clientToLeave.clientEmployeeId || clientToLeave.Id
        }
      ]
    };
    try {
      const response = await Postrequestcall(DELETE_CLIENT_EMPLOYEES, payload, accessToken);
      // Check for success (assuming 200 OK)
      if (response && response.status === 201) {
        // Remove client from local list
        const updatedClients = loginData.userInformation.ClientsList.filter(
          (c) => c.ClientId !== clientToLeave.ClientId
        );

        // Update Redux
        const updatedLoginData = {
          ...loginData,
          userInformation: {
            ...loginData.userInformation,
            ClientsList: updatedClients
          }
        };
        dispatch(setLogindata(updatedLoginData));

        const isLeavingCurrent = selectedClientData?.ClientId === clientToLeave.ClientId;

        if (isLeavingCurrent) {
          dispatch(setSelectedClientdata(null));
          dispatch(setSelectedAppPermissions([]));
          if (updatedClients.length === 0) {
            navigate("/home");
          } else {
            dispatch(setShowOrganizationModal(true));
            navigate("/select/org");
          }
        }
      } else if (response && response.status === 400) {
        if (response?.data?.data?.[0]?.message) {
          alert(response?.data?.data?.[0]?.message)
        }
        else {
          alert("Something went wrong");
        }
      }
      else {
        alert("Something went wrong");
        console.error("Failed to leave organization", response);
      }
    } catch (error) {
      console.error("Error leaving organization:", error);
    } finally {
      setLoadingLeave(false);
      setOpenLeaveModal(false);
      setClientToLeave(null);
    }
  };

  return (
    <>
      <Menu
        autoFocus={false}
        anchorEl={anchorEl}
        id="account-menu"
        open={menuView}
        onClose={handleClose} // Use the updated function
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              maxHeight: "calc(100vh - 24px)",
              width: "350px",
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                zIndex: 0
              }
            }
          }
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
        <Stack
          sx={{
            width: "350px",
            maxHeight: "calc(100vh - 24px)",
            overflowY: "auto",
            overflowX: "hidden"
          }}>
          {!selectedClientData?.HideBiFree && <>
            <ListItem sx={{ m: 0 }} disablePadding>
              <ListItemButton sx={{ pt: 0, pb: 1 }} onClick={(e) => !isCurrentClientRestricted && onProfile(e, "BuildID Free")}>
                <ListItemAvatar>
                  <Avatar alt="contact-PictureUrl" src={loginData?.pictureUrl} />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Stack direction={"row"} spacing={0.5}>
                      <Typography variant="body1" maxWidth={"150px"} noWrap>
                        {loginData?.userInformation?.FirstName}
                      </Typography>
                      <Typography variant="body1" maxWidth={"150px"} noWrap>
                        {loginData?.userInformation?.LastName}
                      </Typography>
                    </Stack>
                  }
                  secondary={
                    <Typography variant="body2" sx={{ color: "text.secondary" }} maxWidth={"200px"} noWrap>
                      {loginData?.userInformation?.TradeName !== ""
                        ? loginData?.userInformation?.TradeName
                        : "No Trade"}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
            <Divider />
            <Divider />
          </>}

          {/* Pending Invitations Section */}
          {loginData?.userInformation?.PendingInvitations?.length > 0 && (
            <>
              <List sx={{ pb: 1,
                  maxHeight: "180px",
                  overflowY: "auto",
                  overflowX: "hidden", lineHeight: "30px",
                      color: "#ff9800",
                      bgcolor: "background.paper" }} disablePadding subheader={ <ListSubheader>
                    {TEXT_PENDING_INVITATIONS}
                  </ListSubheader>
                }>
                {loginData.userInformation.PendingInvitations.map((invite) => (
                  <ListItem sx={{ m: 0 }} disablePadding key={invite.ClientId}>
                    <ListItemButton sx={{ pt: 0.5, pb: 0.5, flexDirection: 'column', alignItems: 'flex-start' }}>
                      <Stack direction="row" sx={{ alignItems: "center" }} width="100%">
                        <ListItemAvatar>
                          <Avatar
                            alt={invite.OrganizationName || invite.ClientName || "Invitation"}
                            src={invite.ClientLogo || invite.Logo || ''}
                            sx={{
                              bgcolor: (invite.ClientLogo || invite.Logo) ? 'white' : 'orange',
                              border: '1px solid #eee',
                              color: 'white',
                              fontWeight: 'bold',
                              img: { objectFit: 'contain' }
                            }}
                          >
                            {!invite.ClientLogo && !invite.Logo && (invite.OrganizationName?.[0] || invite.ClientName?.[0] || 'Inv')}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={invite.OrganizationName || invite.ClientName || `Invitation to Join Organization ${invite.ClientId}`}
                          secondary={
                            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                              Invited by: {invite.InvitedBy || "Admin"}
                            </Typography>
                          }
                        />
                      </Stack>
                      <Button
                        size="small"
                        variant="outlined"
                        sx={{ mt: 1, ml: 7, textTransform: 'none', fontSize: '12px' }}
                        onClick={() => handleViewInvite && handleViewInvite(invite)}
                      >
                        View Invite
                      </Button>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
              <Divider />
            </>
          )}

          {loginData?.userInformation?.ClientsList?.length !== 0 ? (
            <>
              <List
                sx={{
                  pb: 1,
                  maxHeight: "240px",
                  overflowY: "auto",
                }}
                disablePadding
                subheader={<ListSubheader>{TEXT_ACCOUNTS}</ListSubheader>}>
                {sortedClientsList.filter(client => {
                  // Check if we should hide BuildID Free based on CURRENT client context
                  if (isCurrentClientRestricted && client.OrganizationName === "BuildID Free") {
                    return false;
                  }
                  return true;
                }).map((client) => {
                  return (
                    <ListItem sx={{ m: 0, alignItems: "center" }} disablePadding key={client.ClientId} secondaryAction={ <Stack direction="row" spacing={0}>
                          {selectedClientData?.ClientId == client.ClientId && window.location.pathname.includes("/client") && (
                            <IconButton size="small" color="primary">
                              <CheckIcon fontSize="small" />
                            </IconButton>
                          )}
                          {client.OrganizationName !== "BuildID Free" && (
                            <IconButton
                              size="small"
                              color="default" // Changed to default to not be too alarming, or error if we want it red
                              onClick={(e) => {
                                e.stopPropagation();
                                handleLeaveClick(client);
                              }}
                              title="Leave Organization"
                            >
                              <ExitToAppIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Stack>
                      }>
                      <ListItemButton
                        sx={{ pt: 0.5, pb: 0.5 }}
                        onClick={(e) => {
                          handleClientActive(client?.ClientId, client?.ClientEmployeeId);
                          handleCurrentClientChange(
                            e,
                            client?.hasOwnProperty("OrganizationName")
                              ? client?.OrganizationName
                              : "BuildID Free"
                          );
                          handleClose();
                        }}>
                        <ListItemAvatar>
                          <Avatar alt="contact-PictureUrl" src={client?.ClientLogo} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography maxWidth={"160px"} noWrap>
                              {client?.hasOwnProperty("OrganizationName")
                                ? client?.OrganizationName == "BuildID Free"
                                  ? "BuildID"
                                  : client?.OrganizationName
                                : "BuildID"}
                            </Typography>
                          }
                          secondary={
                            <Stack>
                              <Typography
                                variant="body2"
                                sx={{ color: "text.secondary" }}
                                maxWidth={"160px"}
                                noWrap>
                                {client?.OrganizationName !== "BuildID Free"
                                  ? "BuildID Client"
                                  : "Free"}
                              </Typography>
                            </Stack>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
              <Divider />
            </>
          ) : null}
          {/* <Divider /> */}
          <Stack sx={{ pt: 1 }}>
            {!pathname.includes("client") && !isCurrentClientRestricted && (
              <>
                <MenuItem
                  dense
                  onClick={() => {
                    handleReferClick();
                    setMenView(false);
                  }}>
                  <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                    <QrCode2Icon fontSize="small" sx={{ color: "GrayText" }} />
                    <Typography sx={{ color: "text.secondary" }} variant="body2">
                      {TEXT_REFER_SOMEONE_TO_BUILDID}
                    </Typography>
                  </Stack>
                </MenuItem>
                <MenuItem
                  dense
                  onClick={() => {
                    navigate("/reward-store/account-activity");
                    setMenView(false);
                  }}>
                  <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                    <AccessTimeIcon fontSize="small" sx={{ color: "GrayText" }} />
                    <Typography sx={{ color: "text.secondary" }} variant="body2">
                      {TEXT_ACCOUNT_ACTIVITY_HEADER}
                    </Typography>
                  </Stack>
                </MenuItem>
                <MenuItem
                  dense
                  onClick={() => {
                    navigate("/settings");
                    setMenView(false);
                  }}>
                  <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                    <SettingsIcon fontSize="small" sx={{ color: "GrayText" }} />
                    <Typography sx={{ color: "text.secondary" }} variant="body2">
                      {TEXT_SETTINGS}
                    </Typography>
                  </Stack>
                </MenuItem>
                <MenuItem
                  dense
                  onClick={() => {
                    dispatch(setSelectedClientdata({}));
                    dispatch(setSelectedAppPermissions([]));
                    navigate("/tutorial-videos");
                    setMenView(false);
                  }}>
                  <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                    <OndemandVideoIcon fontSize="small" sx={{ color: "GrayText" }} />
                    <Typography sx={{ color: "text.secondary" }} variant="body2">
                      {TEXT_TUTORIAL_VIDEOS}
                    </Typography>
                  </Stack>
                </MenuItem>
              </>
            )}
            {pathname.includes("client") && selectedClientData?.ClientId && (
              <MenuItem
                dense
                onClick={() => {
                  navigate(`/client/${selectedClientData?.ClientId}/client-tutorial-videos`);
                  setMenView(false);
                }}>
                <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                  <OndemandVideoIcon fontSize="small" sx={{ color: "GrayText" }} />
                  <Typography sx={{ color: "text.secondary" }} variant="body2">
                    {TEXT_TUTORIAL_VIDEOS}
                  </Typography>
                </Stack>
              </MenuItem>
            )}

            {pathname.includes("client") &&
              ((loginData?.userInformation?.ClientsList || []).some((c) => c.HideBiFree === false) ||
                ((loginData?.userInformation?.ClientsList || []).length === 0 &&
                  (loginData?.userInformation?.PendingInvitations || []).length === 0)) && (
                <MenuItem
                  dense
                  onClick={(e) => {
                    setMenView(false);
                    dispatch(setSelectedClientdata({}));
                    dispatch(setSelectedAppPermissions([]));
                    if (onProfile) {
                      onProfile(e, "BuildID Free");
                    } else {
                      navigate("/home");
                    }
                  }}>
                  <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                    <img
                      src={BuildIdLogo}
                      alt="Build ID"
                      style={{ height: "16px", width: "16px", objectFit: "contain" }}
                    />
                    <Typography sx={{ color: "text.secondary", fontWeight: 600 }} variant="body2">
                      Go to Build ID
                    </Typography>
                  </Stack>
                </MenuItem>
              )}

            <MenuItem dense onClick={(e) => onLogout(e, "BuildID Free")}>
              <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                <LogoutIcon fontSize="small" sx={{ color: "GrayText" }} />
                <Typography sx={{ color: "text.secondary" }} variant="body2">
                  {TEXT_LOGOUT}
                </Typography>
              </Stack>
            </MenuItem>

            <Grid sx={{ pb: 1,  pt: 1, alignItems: "center" }} container spacing={0.5}>
              {/* Privacy Policy */}
              <Grid sx={{ display: "flex", justifyContent: "center" }} size={3.5}>
                <Typography variant="body2" onClick={() => setMenView(false)}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.iubenda.com/privacy-policy/90161377"
                    style={{ textDecoration: "none", color: BIGrey }}>
                    {TEXT_PRIVACY_POLICY}
                  </a>
                </Typography>
              </Grid>

              {/* Terms and Conditions */}
              <Grid sx={{ display: "flex", justifyContent: "center" }} size={5}>
                <Typography variant="body2" onClick={() => setMenView(false)}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.iubenda.com/terms-and-conditions/90161377"
                    style={{ textDecoration: "none", color: BIGrey }}>
                    {TEXT_TERMS_AND_CONDITIONS}
                  </a>
                </Typography>
              </Grid>

              {/* Version Info */}
              <Grid sx={{ display: "flex", justifyContent: "center" }} size={3.5}>
                <Typography variant="body2" sx={{ color: BIGrey }}>
                  BuildID v{packageInfo?.version}
                </Typography>
              </Grid>
            </Grid>
          </Stack>
        </Stack>
      </Menu>

      <Dialog
        open={openLeaveModal}
        onClose={() => !loadingLeave && setOpenLeaveModal(false)}
        PaperProps={{
          style: {
            borderRadius: "12px",
            padding: "8px",
            maxWidth: "400px",
            width: "100%"
          }
        }}
      >
        <Stack direction="column" sx={{ pt: 3, alignItems: "center", display: "flex" }}  >
          <Avatar sx={{ bgcolor: "#FEE4E2", color: "#D92D20", width: 48, height: 48, mb: 2 }}>
            <WarningAmberRoundedIcon sx={{ fontSize: 28 }} />
          </Avatar>
          <DialogTitle sx={{ p: 0, mb: 1, fontWeight: 700, fontSize: "1.25rem", color: "#101828" }}>
            Leave Organization
          </DialogTitle>
        </Stack>
        <DialogContent sx={{ textAlign: "center", pb: 3, pt: 0 }}>
          <DialogContentText sx={{ color: "#667085", fontSize: "0.95rem" }}>
            Are you sure you want to leave <b>{clientToLeave?.OrganizationName}</b>? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", px: 2, pb: 2, gap: 1.5 }}>
          <Button
            onClick={() => setOpenLeaveModal(false)}
            variant="outlined"
            disabled={loadingLeave}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              color: "#344054",
              borderColor: "#D0D5DD",
              flex: 1,
              '&:hover': { borderColor: "#D0D5DD", bgcolor: "#F2F4F7" }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmLeave}
            variant="contained"
            color="error"
            disabled={loadingLeave}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              flex: 1,
              bgcolor: "#D92D20",
              '&:hover': { bgcolor: "#B42318", boxShadow: "none" }
            }}
          >
            {loadingLeave ? <CircularProgress size={24} color="inherit" /> : "Yes, Leave"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ProfileMenu;
